import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { useDispatch } from "react-redux";
import i18n from "i18next";


import { CSSTransition } from 'react-transition-group';
import PrimeReact, { locale } from 'primereact/api';

import AppTopbar from '@components/AppTopbar';
// import { AppFooter } from './AppFooter';
import AppMenu from '@components/AppMenu';
import AppProfile from '@components/AppProfile';
import AppConfig from '@components/AppConfig';
import LoadingView from '@components/LoadingView';

import { getCatalogs, setFormattedCatalogs } from '@actions/catalogs';
import { getAllLanguagesList, getDictionaryLanguage } from '@actions/locale';
import { getCompleteProfileUser, validatePermissionView, validatePermissionAction } from '@actions/sessionPermission';

import { setConfigCalendarLanguage, validateValuesLanguages } from '@utils/general'

import catalogPermissionsId from '@constants/catalogPermissionsId'
import { CURRENT_LENGUAGE } from '@constants/general'
import { SET_VALUES_SETTINGS } from '@constants/actionType'

import '@styles/flags/flags.css';
import '@styles/layout.scss';
import './style.scss';

const LayoutAdmin = ({ children }) => {
  const [layoutMode, setLayoutMode] = useState('static');
  const [layoutColorMode, setLayoutColorMode] = useState('light');
  const [staticMenuInactive, setStaticMenuInactive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [inputStyle, setInputStyle] = useState('outlined');
  const [ripple, setRipple] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [languageKeySelected, setLanguageKeySelected] = useState('');

  const sidebar = useRef();
  const mountedRef = useRef(true);


  const dispatch = useDispatch();
  const history = useHistory();

  let menuClick = false;

  const addClass = (element, className) => {
    const el = element;
    if (el.classList) el.classList.add(className);
    else el.className += ` ${className}`;
  };

  const removeClass = (element, className) => {
    const el = element;
    if (el.classList) el.classList.remove(className);
    else
      el.className = el.className.replace(
        new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'),
        ' '
      );
  };

  const initialActions = useCallback(async () => {
    const params = {
      type: 'all'
    };
    
    const responsePermisos = await dispatch(getCompleteProfileUser())
    const isFullAdmin = responsePermisos?.data?.isFullAdmin
    await dispatch({ type: SET_VALUES_SETTINGS, payload: { isFullAdmin } })
    const response = await dispatch(getAllLanguagesList(params));
    if (!response?.status) {

      const getDictionaryPromises = response.data.map(item => dispatch(getDictionaryLanguage(item.clave)))
      const getDictionaryResolve = await Promise.all(getDictionaryPromises)
      getDictionaryResolve.map(async (language, index) => {
        const valiteEmptyValues = validateValuesLanguages(language.data)
        return i18n.addResourceBundle(response.data[index].clave, 'translation', valiteEmptyValues, true, true)
      })
      i18n.changeLanguage(localStorage.getItem(CURRENT_LENGUAGE) || process.env.LOCALE);
      setConfigCalendarLanguage(response.data)
      locale(localStorage.getItem(CURRENT_LENGUAGE) || process.env.LOCALE)
    }
    await dispatch(getCatalogs());
    await dispatch(setFormattedCatalogs());
    setTimeout(() => {
      setPageLoading(false)
    }, 100)
  }, [mountedRef]);

  useEffect(() => {
    initialActions();
    return () => {
      mountedRef.current = false;
    };
  }, [])

  useEffect(() => {
    if (mobileMenuActive) {
      addClass(document.body, 'body-overflow-hidden');
    } else {
      removeClass(document.body, 'body-overflow-hidden');
    }
  }, [mobileMenuActive]);

  const onInputStyleChange = (inputStyleV) => {
    setInputStyle(inputStyleV);
  };

  const onRipple = (e) => {
    PrimeReact.ripple = e.value;
    setRipple(e.value);
  };

  const onLayoutModeChange = (mode) => {
    setLayoutMode(mode);
  };

  const onColorModeChange = (mode) => {
    setLayoutColorMode(mode);
  };

  const onWrapperClick = () => {
    if (!menuClick) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
    menuClick = false;
  };

  const isDesktop = () => window.innerWidth > 1024;

  const onToggleMenu = (event) => {
    menuClick = true;

    if (isDesktop()) {
      if (layoutMode === 'overlay') {
        setOverlayMenuActive((prevState) => !prevState);
      } else if (layoutMode === 'static') {
        setStaticMenuInactive((prevState) => !prevState);
      }
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }
    event.preventDefault();
  };

  const onSidebarClick = () => {
    menuClick = true;
  };

  const onMenuItemClick = (event) => {
    if (!event.item.items) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
  };

  const menu = [
    // { label: `${i18n.t('Dashboard')}`, icon: 'pi pi-fw pi-home', to: '/dashboard' },
    // {
    //   label: i18n.t('Usuarios'),
    //   icon: 'pi pi-fw pi-briefcase',
    //   items: [
    //     { label: i18n.t('Usuarios internos') , icon: 'pi pi-fw pi-users', to: '/users/internal', },
    //     { label: i18n.t('Administradores'), icon: 'pi pi-fw pi-star', to: '/admins' }
    //   ]
    // },
    // {
    //   label: i18n.t('Secciones'),
    //   icon: 'pi pi-fw pi-palette',
    //   to: '/sections',
    // },
    // {
    //   label: i18n.t('Documentos'),
    //   icon: 'pi pi-fw pi-file',
    //   to: '/documents'
    // },
    // {
    //   label: i18n.t('Administración'),
    //   icon: 'pi pi-fw pi-microsoft',
    //   items: [
    //     { label: i18n.t('Empresas'), icon: 'pi pi-fw pi-users', to: '/business', },
    //     { label: i18n.t('Países'), icon: 'pi pi-fw pi-map', to: '/countries' },
    //     { label: i18n.t('Idioma'), icon: 'pi pi-fw pi-globe', to: '/languages' },
    //     { label: i18n.t('Perfiles'), icon: 'pi pi-ticket', to: '/profiles' }
    //   ]
    // }
  ];

  if (
    dispatch(validatePermissionAction(catalogPermissionsId.VER_USUARIOS_INTERNOS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.CREAR_ADMINISTRADORES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.AJUSTAR_INFORMACION_ADMINISTRADORES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_ADMINISTRADORES))
  ) {
    const menuUser = {
      label: i18n.t('Usuarios'),
      icon: 'pi pi-fw pi-briefcase',
      items: []
    }
    if (dispatch(validatePermissionAction(catalogPermissionsId.VER_USUARIOS_INTERNOS))) {
      menuUser.items.push({ label: i18n.t('Usuarios internos'), icon: 'pi pi-fw pi-users', to: '/users/internal', })
    }
    if (
      dispatch(validatePermissionAction(catalogPermissionsId.CREAR_ADMINISTRADORES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.AJUSTAR_INFORMACION_ADMINISTRADORES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_ADMINISTRADORES))
    ) {
      menuUser.items.push({ label: i18n.t('Administradores'), icon: 'pi pi-fw pi-star', to: '/admins' })
    }

    if (dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_PROVEDOR))) {
      menuUser.items.push({ label: i18n.t('Proveedores'), icon: 'pi pi-fw pi-user', to: '/supplier/search' })
    }


    menu.push(menuUser)
  }

  if (
    dispatch(validatePermissionAction(catalogPermissionsId.CREAR_EDITAR_SECCION)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_SECCION)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_SECCION)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ORDENAR_SECCION)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.EDITAR_TODAS_SECCIONES))
  ) {
    menu.push({
      label: i18n.t('Secciones'),
      icon: 'pi pi-fw pi-palette',
      to: '/sections',
    })
  }

  if (
    dispatch(validatePermissionAction(catalogPermissionsId.AGREGAR_DOCUMENTO)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.EDITAR_DOCUENTO)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_DOCUMENTO)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_DOCUMENTOS_AUTORIZADOS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ORDENAR_DOCUMENTO))
  ) {
    menu.push({
      label: i18n.t('Documentos'),
      icon: 'pi pi-fw pi-file',
      to: '/documents'
    })
  }

  if (dispatch(validatePermissionAction(catalogPermissionsId.ACCESO_REPORTES))) {
    menu.push({
      label: i18n.t('Reportes'),
      icon: 'pi pi-fw pi-chart-bar',
      to: '/reports'
    })
  }

  if (dispatch(validatePermissionAction(catalogPermissionsId.ACCESO_CORREOS))) {
    menu.push({
      label: i18n.t('Correos'),
      icon: 'pi pi-fw pi-send',
      to: '/emails'
    })
  }

  if (dispatch(validatePermissionAction(catalogPermissionsId.ACCESO_BITACORA)) ) {
    menu.push({
      label: i18n.t('Bitacora'),
      icon: 'pi pi-fw pi-slack',
      to: '/bitacora'
    })
  }

  if (
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_EVALUADORES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_GESTORES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_COORDINADORES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_ROLES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_DICCIONARIO_PROCESOS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_ANEXOS_PROCESOS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.VALIDAR_SELLO_DIGITAL)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.EDICION_DE_ANEXO_FD)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.TRADUCCION_DE_TEXTOS_FD)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_FD)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.TRADUCCION_INACTIVOS_FD))
  ) {
    const menuProcesos = {
      label: i18n.t('Procesos'),
      icon: 'pi pi-filter',
      items: []
    }
    if (
      dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_EVALUADORES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_GESTORES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_COORDINADORES))
    ) {
      menuProcesos.items.push({ label: i18n.t('Evaluadores'), icon: 'pi pi-fw pi-eye', to: '/evaluators' })
    }
    if (dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_ROLES))) {
      menuProcesos.items.push({ label: i18n.t('Roles en procesos'), icon: 'pi pi-fw pi-sitemap', to: '/roles' })
    }

    if (dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_DICCIONARIO_PROCESOS))) {
      menuProcesos.items.push({ label: i18n.t('Diccionario'), icon: 'pi pi-fw pi-book', to: '/process-dictionary' })
    }

    if (dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_ANEXOS_PROCESOS))) {
      menuProcesos.items.push({ label: i18n.t('Anexos'), icon: 'pi pi-fw pi-folder-open', to: '/anexos' })
    }
    if (dispatch(validatePermissionAction(catalogPermissionsId.VALIDAR_SELLO_DIGITAL))) {
      menuProcesos.items.push({ label: i18n.t('Sello digital'), icon: 'pi pi-key', to: '/validate-digital-stamp' })
    }

    if (
      dispatch(validatePermissionAction(catalogPermissionsId.EDICION_DE_ANEXO_FD)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.TRADUCCION_DE_TEXTOS_FD)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_FD)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.TRADUCCION_INACTIVOS_FD))
    ) {
      menuProcesos.items.push({ label: i18n.t('Formularios Digitales'), icon: 'pi pi-fw pi-mobile', to: '/digital-form' })
    }
    


    menu.push(menuProcesos)
  }


  if (
    dispatch(validatePermissionAction(catalogPermissionsId.CREAR_PERFILES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.AJUSTAR_INFORMACION_PERFILES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_PERFILES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.CREAR_EMPRESA)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.AJUSTAR_EMPRESA)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.AGREGAR_PAIS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.EDITAR_PAISES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_PAISES)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.AGREGAR_IDIOMAS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.EDITAR_IDIOMAS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_IDIOMAS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_IDIOMAS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.LISTA_NEGRA_DE_DOMINIOS)) ||
    dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_TIPO_USUARIOS))
  ) {
    const menuAdmin = {
      label: i18n.t('Administración'),
      icon: 'pi pi-fw pi-microsoft',
      items: []
    }
    // { label: i18n.t('Empresas'), icon: 'pi pi-fw pi-users', to: '/business', },
    // { label: i18n.t('Países'), icon: 'pi pi-fw pi-map', to: '/countries' },
    // { label: i18n.t('Idioma'), icon: 'pi pi-fw pi-globe', to: '/languages' },

    if (
      dispatch(validatePermissionAction(catalogPermissionsId.CREAR_EMPRESA)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.AJUSTAR_EMPRESA))
    ) {
      menuAdmin.items.push({ label: i18n.t('Empresas'), icon: 'pi pi-fw pi-users', to: '/business', })
    }

    if (
      dispatch(validatePermissionAction(catalogPermissionsId.AGREGAR_PAIS)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.EDITAR_PAISES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_PAISES))
    ) {
      menuAdmin.items.push({ label: i18n.t('Países'), icon: 'pi pi-fw pi-map', to: '/countries' })
    }

    if (
      dispatch(validatePermissionAction(catalogPermissionsId.AGREGAR_IDIOMAS)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.EDITAR_IDIOMAS)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_IDIOMAS)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_IDIOMAS))
    ) {
      menuAdmin.items.push({ label: i18n.t('Idioma'), icon: 'pi pi-fw pi-globe', to: '/languages' })
    }

    if (
      dispatch(validatePermissionAction(catalogPermissionsId.CREAR_PERFILES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.AJUSTAR_INFORMACION_PERFILES)) ||
      dispatch(validatePermissionAction(catalogPermissionsId.ELIMINAR_PERFILES))
    ) {
      menuAdmin.items.push({ label: i18n.t('Perfiles'), icon: 'pi pi-ticket', to: '/profiles' })
    }

    if (dispatch(validatePermissionAction(catalogPermissionsId.LISTA_NEGRA_DE_DOMINIOS))) {
      menuAdmin.items.push({ label: i18n.t('Lista negra de dominios'), icon: 'pi pi-book', to: '/blacklist-domains' })
    }

    if (dispatch(validatePermissionAction(catalogPermissionsId.ADMINISTRAR_TIPO_USUARIOS))) {
      menuAdmin.items.push({ label: i18n.t('Tipos de usuarios'), icon: 'pi pi-sitemap', to: '/type-users' })
    }

    menu.push(menuAdmin)
  }

  const isSidebarVisible = () => {
    if (isDesktop()) {
      if (layoutMode === 'static') return !staticMenuInactive;
      if (layoutMode === 'overlay') return overlayMenuActive;
      return true;
    }
    return true;
  };

  const validateViewAction = async () => {
    let pathRedirect = ''
    if (menu[0]?.items) pathRedirect = menu[0].items[0].to
    else pathRedirect = menu[0].to
    const validate = await dispatch(validatePermissionView(history.location.pathname))
    if (!validate && history.location.pathname !== pathRedirect) return history.push(pathRedirect);
    return true
  }

  const logo =
    layoutColorMode === 'dark'
      ? 'assets/layout/images/logo-white.svg'
      : 'assets/layout/images/logo.svg';

  const wrapperClass = classNames('layout-wrapper', {
    'layout-overlay': layoutMode === 'overlay',
    'layout-static': layoutMode === 'static',
    'layout-static-sidebar-inactive':
      staticMenuInactive && layoutMode === 'static',
    'layout-overlay-sidebar-active':
      overlayMenuActive && layoutMode === 'overlay',
    'layout-mobile-sidebar-active': mobileMenuActive,
    'p-input-filled': inputStyle === 'filled',
    'p-ripple-disabled': ripple === false,
  });

  const sidebarClassName = classNames('layout-sidebar', {
    'layout-sidebar-dark': layoutColorMode === 'dark',
    'layout-sidebar-light': layoutColorMode === 'light',
  });
  if (pageLoading) return (<LoadingView />)
  return (
    <div
      className={wrapperClass}
      role="button"
      onClick={onWrapperClick}
      aria-hidden="true"
    >
      <AppTopbar onToggleMenu={onToggleMenu} languageKeySelected={languageKeySelected} />

      <CSSTransition
        classNames="layout-sidebar"
        timeout={{ enter: 200, exit: 200 }}
        in={isSidebarVisible()}
        unmountOnExit
      >
        <div
          ref={sidebar}
          className={sidebarClassName}
          onClick={onSidebarClick}
          aria-hidden="true"
        >
          <div
            className="layout-logo p-pt-6 p-pb-3"
            style={{ cursor: 'pointer' }}
            onClick={() => history.push('/dashboard')}
            aria-hidden="true"
          >
            <img alt="Logo" src='/assets/img/logo-compliance.svg' />
          </div>
          <AppProfile setLanguageSelectedMain={setLanguageKeySelected} />
          <AppMenu model={menu} onMenuItemClick={onMenuItemClick} />
        </div>
      </CSSTransition>

      {/* <AppConfig
        rippleEffect={ripple}
        onRippleEffect={onRipple}
        inputStyle={inputStyle}
        onInputStyleChange={onInputStyleChange}
        layoutMode={layoutMode}
        onLayoutModeChange={onLayoutModeChange}
        layoutColorMode={layoutColorMode}
        onColorModeChange={onColorModeChange}
      /> */}
      {validateViewAction() && (
        <div className="layout-main">{children}</div>
      )}
      {/* <AppFooter /> */}
    </div>
  );
};

export default LayoutAdmin;
